import React, { FC } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import { Trans } from 'react-i18next';

import { FullScreenLayout } from './';

const styles = (theme: Theme) =>
  createStyles({
    error: {
      display: 'inline-block',
    },
    problem: {
      display: 'inline-block',
      fontSize: theme.typography.pxToRem(36),
    },
  });

interface IProps extends WithStyles<typeof styles> {}

const NotFound: FC<IProps> = ({ classes }) => (
  <Grid container alignItems="center" justify="center">
    <Grid item>
      <FullScreenLayout
        message={
          <div>
            <Typography className={classes.error} variant="h2">
              <Trans i18nKey="components:404Header" />
            </Typography>
            &nbsp;
            <Typography className={classes.problem}>
              <Trans i18nKey="components:404SubHeader" />
            </Typography>
          </div>
        }
      />
    </Grid>
  </Grid>
);

export default withStyles(styles)(NotFound);
